// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___1ppE7","title":"Toolbox__title___3kSmg","row":"Toolbox__row___2eSLK","colorPicker":"Toolbox__colorPicker___sNOd4","label":"Toolbox__label___29rpc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Container/Toolbox/Toolbox.scss
// module id = 984
// module chunks = 0